module.exports = __webpack_public_path__ + "img/Flag_of_San_Marino.16dab5ad.svg";